<template>
  <div v-show="show" class="mdl-grid">
    <div class="mdl-cell mdl-cell--2-col mdl-cell--hide-tablet mdl-cell--hide-phone"></div>
    <div class="mdl-cell mdl-cell--8-col mdl-cell--8-col-tablet mdl-typography--text-right">
      <button v-for="button in buttons" @click="button.onclick" :disabled="button.disabled"
        class="mdl-button mdl-js-button mdl-js-ripple-effect">
        {{ button.text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      buttons: []
    }
  },
  methods: {
    init (actionbar) {
      this.show = actionbar.show
      this.buttons = actionbar.buttons
    },
    destroy () {
      this.show = false
      this.buttons = []
    }
  },
  mounted () {
    this.$actionbar.init = this.init
    this.$actionbar.destroy = this.destroy
  }
}
</script>

<style lang="css" scoped>
  footer {
    position: sticky;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 66px;
    padding: 1rem 2rem;
    background-color: #fff;
    z-index: 100;
  }

  .mdl-grid {
    width: 100%;
    min-height: 68px;
  }
</style>


// WEBPACK FOOTER //
// index.vue?6e7f53bc